import {Injectable, inject} from '@angular/core';
// import { Router } from '@angular/router';
import {HttpClient} from '@angular/common/http';
import {Observable, Observer, catchError, map, throwError} from 'rxjs';
import {environment} from '../../environments/environment';
import {CustomerService, ICustomerLoginRecord, ICustomerLogin} from '../Common/services/customer.service';
import { AuthService } from '../Common/services/auth.service';

export type ICustomerLoginRecordType = ICustomerLoginRecord;

@Injectable({
    providedIn: 'root'
})
export class LoginService {
    private _url_login_base = environment.url_login_base;
    private _url_base = environment.url_base;
    private _CustomerS = inject(CustomerService);
    private http = inject(HttpClient);
    private _authS = inject(AuthService);
    // ===========================================================================
    
    // ===========================================================================
    // ---------------------------------------------------------------------------
    public submitLogin(user: string, pwd: string): Observable<boolean> {
        
        return this._CustomerS.submitLogin(this._url_login_base, user, pwd).pipe(
            map((custom_data: ICustomerLogin|boolean) => {
                this._authS.guardarTokens((<ICustomerLogin>custom_data).tokens);
                return (custom_data !== null);
            }),
            catchError((e: any) => {
                this._onLoginFail(e);
                return throwError(() => e);
            })
        );

    }

    // ---------------------------------------------------------------------------
    public submitLogout(): any {
        
        this._CustomerS.submitLogout();
        this._authS.logout();

    }

    // ---------------------------------------------------------------------------
    public sendPasswordRecoveryMail(mail_data: Object): Observable<any> {
        return this._CustomerS.sendPwdRecoveryMail(JSON.stringify(mail_data)).pipe(
            map((response: any) =>   {
                return response;
            }),
            catchError((error: any) => {
                return throwError(() => error);
            })
        );

    }

    // ===========================================================================
    // ---------------------------------------------------------------------------
    public onLoginOK(response: ICustomerLoginRecord): void {}
    
    // ===========================================================================
    // ---------------------------------------------------------------------------
    private _onLoginFail(error: any): void {
        console.log(error);

        this._CustomerS.logged = 0;
        this._CustomerS.resetRecord();

    }

}
